<template >
  <v-layout align-start>
    <v-flex>
      <!-- Tabs-->
      <div v-if="TablaVisible">
        <v-dialog v-model="tramitedetallemmodal" max-width="600">
          <v-card>
            <v-card-title class="headline">Documentos del Tramite</v-card-title>

            <v-col v-for="n in tramitedetalles" :key="n.tramitedetalleid" cols="12" md="12">
              <v-alert
                type="error"
                v-if="n.documentovigente==0"
                color="#AF0B0E"
                dark
                dense
              >{{n.tipodocumentonombre}}</v-alert>

              <v-alert
                type="info"
                v-if="n.documentovigente>0"
                color="#400788"
                dark
                dense
              >{{n.tipodocumentonombre}}</v-alert>
            </v-col>
            <v-card-actions>
              <v-btn color="secondary" @click="TramiteDetallesmostrarocultar()">Cancelar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-col cols="12" md="12">
          <v-alert
            type="info"
            class="subtitle-2 text-center"
            color="primary"
          >HISTORIAL DE DOCUMENTOS VIGENTES DEL SOCIO</v-alert>
        </v-col>

        <v-col cols="12" sm="12" offset-sm="12" align="center" justify="center">
          <v-card>
            <v-container fluid>
              <v-btn color="secondary" @click="close()">Cancelar</v-btn>
              <v-col cols="12" sm="12" md="12" v-show="valida">
                <v-row class="red--text" v-for="v in validamensaje" :key="v" v-text="v"></v-row>
              </v-col>

              <v-row>
                <v-col cols="12" md="11">
                  <v-select
                    v-model="tramiteid"
                    :items="tramiteselect"
                    label="Tramites"
                    v-on:change="TramiteDetallesDocumentos()"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="1">
                  <v-btn @click="TramiteDetallesmostrar()" small fab dark color="teal">
                    <v-icon dark>list</v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <v-row>
                <v-col v-for="n in sociodoc" :key="n.documentoid" cols="12" md="6">
                  <v-card max-width="800" class="mx-auto">
                    <v-row>
                      <v-col cols="12" md="6">
                        <v-card height="350">
                          <v-card-text
                            v-if="n.tipodocumentoobligatorio==1"
                            align="center"
                            justify="center"
                          >
                            <v-alert color="#400788" dark dense>Documento Obligatorio</v-alert>
                          </v-card-text>

                          <v-card-text
                            v-if="n.tipodocumentoobligatorio==0"
                            align="center"
                            justify="center"
                          >
                            <v-alert color="#0296FF" dark dense>Documento Normal</v-alert>
                          </v-card-text>

                          <p class="font-weight-black">{{n.tipodocumentonombre}}</p>

                          <v-card-text align="center" justify="center">
                            <p>Fecha del Documento</p>
                            <v-alert color="#BB0707" dark dense>{{getHumanDate(n.documentofecha)}}</v-alert>

                            <p>Fecha de Vencimiento</p>
                            <v-alert v-if="getHumanDate(n.documentofechacaduca)=='01/01/1900'"
                              color="#BB0707"
                              dark
                              dense
                            >NO APLICA</v-alert>

                             <v-alert v-if="getHumanDate(n.documentofechacaduca)!='01/01/1900'"
                              color="#BB0707"
                              dark
                              dense
                            >{{getHumanDate(n.documentofechacaduca)}}</v-alert>
                            
                          </v-card-text>
                        </v-card>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-card class="mx-auto" max-width="800">
                          <v-img
                            v-if="n.documentoextencion==1"
                            :src="imageApiPath(n.documentoruta)"
                            height="100%"
                            width="100%"
                          ></v-img>

                          <iframe
                            v-if="n.documentoextencion==2"
                            :src="imageApiPath(n.documentoruta)"
                            height="320"
                            width="230"
                          ></iframe>
                        </v-card>
                      </v-col>
                    </v-row>

                    <v-container>
                      <v-row no-gutters>
                        <v-col cols="12" md="4">
                          <p class="font-weight-black text-sm-left">CuentaID</p>
                        </v-col>
                        <v-col cols="12" md="8">
                          <p class="font-weight-regular text-sm-left">{{n.cuentaid}}</p>
                        </v-col>
                      </v-row>
                      <v-row no-gutters>
                        <v-col cols="12" md="4">
                          <p class="font-weight-black text-sm-left">Cuenta</p>
                        </v-col>
                        <v-col cols="12" md="8">
                          <p class="font-weight-regular text-sm-left">{{n.cuentanombre}}</p>
                        </v-col>
                      </v-row>
                      
                    </v-container>

                    <v-card-text>
                      <p class="font-weight-black">Observacion</p>
                      {{n.documentoobservacion}}
                    </v-card-text>

                    <v-card-actions>
                      <v-btn
                        text
                        color="deep-purple accent-4"
                        :href="imageApiPath(n.documentoruta)"
                        target="_blank"
                        @click="bitacora()"
                      >Descargar</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </div>

      <!-- Cierre Tabs-->

      <v-data-table
        :headers="headers"
        :items="socios"
        :search="search"
        class="elevation-1"
        v-if="TablaVisible==0"
      >
        <template v-slot:top>
          <v-toolbar color="white">
            <v-toolbar-title>Socios</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Búsqueda"
              single-line
              hide-details
              @keyup.enter="listar()"
            ></v-text-field>
            <v-btn v-if="TablaVisible==0" @click="listar()" color="primary" dark class="mb-2">Buscar</v-btn>
            <v-spacer></v-spacer>

            <v-dialog v-model="reportes" max-width="500px">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <div class="text-center">
                      <vue-excel-xlsx
                        :data="data"
                        :columns="columns"
                        :filename="'DocumentosVigente-'+socioid+'-'+new Date().toISOString()"
                        :sheetname="'sheetname'"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn color="success" fab x-large dark>
                              <span style="font-size: 3em;">
                                <i class="fas fa-file-excel" dark v-on="on"></i>
                              </span>
                            </v-btn>
                          </template>
                          <span>Reporte en Excel</span>
                        </v-tooltip>
                      </vue-excel-xlsx>
                    </div>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-icon small class="mr-2" @click="editItem(item)" v-on="on">remove_red_eye</v-icon>
            </template>
            <span>Ver Documentos</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template #activator="{ on }">
              <v-icon small class="mr-2" @click="excel(item)" v-on="on">print</v-icon>
            </template>
            <span>Imprimir Reportes</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="listar">Reset</v-btn>
        </template>
        <template v-slot:item.socioestatus="{ item }">
          <v-chip :color="getColor(item.socioestatus)" dark v-if="item.socioestatus==11">ACTIVO</v-chip>
          <v-chip :color="getColor(item.socioestatus)" dark v-if="item.socioestatus==14">SUSPENDIDO</v-chip>
          <v-chip :color="getColor(item.socioestatus)" dark v-if="item.socioestatus==1">SOLICITUD</v-chip>
          <v-chip :color="getColor(item.socioestatus)" dark v-if="item.socioestatus==13">CANCELADO</v-chip>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      // Variable de Servidor Envia Fotos
      VUE_APP_CLOUDINARY_URL: process.env.VUE_APP_CLOUDINARY_URL,
      // Modal de Fechas
      sociofinscripcion: new Date().toISOString().substr(0, 10),
      sociofnacimiento: new Date().toISOString().substr(0, 10),
      modal: false,
      modal1: false,
      // Selects
      sociodocumentos: [],
      sociodoc: [],
      tramiteselect: [],
      tramitedetalles: [],
      // Datos
      documentoid: "",
      socioid: "",
      socionombre: "",
      sociopaterno: "",
      sociomaterno: "",
      socioestatus: "",
      imagen: "",
      tramiteid: "",
      tramitedetallemmodal: 0,
      detalles: 0,
      // Variable Socio
      socios: [],
      dialog: false,
      TablaVisible: 0,
      headers: [
        { text: "Accion", value: "action", sortable: false },
        { text: "SocioID", value: "socioid" },
        { text: "Nombre", value: "socionombre", sortable: false },
        { text: "Paterno", value: "sociopaterno", sortable: false },
        { text: "Materno", value: "sociomaterno", sortable: false },
        { text: "Estatus", value: "socioestatus", sortable: false }
      ],
      search: "",
      //
      editedIndex: -1,
      //Declaracion de varaibles
      id: "",
      nombre: "",
      descripcion: "",
      // Declara variables de Validacion
      valida: 0,
      validamensaje: [],
      // Declara Varaiables para ctivar o desactivar categorias
      adModal: 0,
      adAccion: 0,
      adNombre: "",
      adId: "",
      dismissSecs: 5,
      dismissCountDown: 0,
      reportes: false,
      //Excel
      columns: [
        {
          label: "documentoid",
          field: "documentoid"
        },
        {
          label: "socioid",
          field: "socioid",
          dataFormat: this.priceFormat
        },
        {
          label: "tipodocumentoid",
          field: "tipodocumentoid"
        },
        {
          label: "tipodocumentonombre",
          field: "tipodocumentonombre"
        },
        {
          label: "documentofecha",
          field: "documentofecha",
          dataFormat: this.getHumanDate
        },
        {
          label: "documentohora",
          field: "documentohora"
        },
        {
          label: "documentoobservacion",
          field: "documentoobservacion"
        },
        {
          label: "documentoruta",
          field: "documentoruta"
        },
        {
          label: "documentoextencion",
          field: "documentoextencion"
        },
        {
          label: "documentoestatus",
          field: "documentoestatus"
        },
        {
          label: "socionombrecompleto",
          field: "socionombrecompleto"
        },
        {
          label: "usuarioid",
          field: "usuarioid"
        },
        {
          label: "tipodocumentoobligatorio",
          field: "tipodocumentoobligatorio"
        },
        {
          label: "documentofechaactual",
          field: "documentofechaactual",
          dataFormat: this.getHumanDate
        },
        {
          label: "documentofechacaduca",
          field: "documentofechacaduca",
          dataFormat: this.getHumanDate
        },
        {
          label: "cuentaid",
          field: "cuentaid"
        },
        {
          label: "tipocuentaid",
          field: "tipocuentaid"
        },
        {
          label: "dia",
          field: "dia"
        },
        {
          label: "mes",
          field: "mes"
        },
        {
          label: "anio",
          field: "anio"
        },
        {
          label: "cuentaimporte",
          field: "cuentaimporte"
        },
        {
          label: "cuentafinscripcion",
          field: "cuentafinscripcion",
          dataFormat: this.getHumanDate
        },
        {
          label: "cuentafvencimiento",
          field: "cuentafvencimiento",
          dataFormat: this.getHumanDate
        },
        {
          label: "cuentanombre",
          field: "cuentanombre"
        }
      ],
      data: []
    };
  },
  // Crea una nueva categoria si es -1
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Reportes" : "Actualizando Tasa";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    this.listar();
    this.select();
  },

  //
  methods: {
    TramiteDetallesmostrar() {
      this.TramiteDetalles();
    },

    TramiteDetallesmostrarocultar() {
      this.tramitedetallemmodal = 0;
    },

    imageApiPath(image) {
      let self = this;
      return this.VUE_APP_CLOUDINARY_URL + image;
    },

    getHumanDate: function(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },

    mostrarNuevo() {
      this.TablaVisible = 1;
    },
    ocultarNuevo() {
      this.TablaVisible = 0;
      this.limpiar();
    },

    getColor(socioestatus) {
      if (socioestatus == 13) return "#3F8103";
      if (socioestatus == 14) return "orange";
      if (socioestatus == 1) return "yellow";
      if (socioestatus == 12) return "#DA0707";
    },

    // metodo listar
    listar() {
      // Variable para cargar los datos del api
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      // Manda llamar al listado de socios
      let url = "";
      if (!me.search) {
        me.search = "";
        url =
          "api/socios/Listar/" +
          this.$store.state.usuario.geograficoestructutaid;

        // Bitacora
        axios
          .post(
            "api/Bitacoras/Crear",
            {
              socioid: 0,
              bitacoranombre: "DOCUMENTO VIGENTE: LISTAR SOCIO DOCUMENTOS",
              usuarioid: me.$store.state.usuario.idusuario
            },
            configuracion
          )
          .then(function(response) {})
          .catch(function(error) {
            console.log(error);
          });
      } else {
        url =
          "api/socios/ListarFiltro/" +
          me.search +
          "/" +
          this.$store.state.usuario.geograficoestructutaid;

        // Bitacora
        axios
          .post(
            "api/Bitacoras/Crear",
            {
              socioid: me.search,
              bitacoranombre: "DOCUMENTO VIGENTE: BUSCA SOCIO DOCUMENTOS",
              usuarioid: me.$store.state.usuario.idusuario
            },
            configuracion
          )
          .then(function(response) {})
          .catch(function(error) {
            console.log(error);
          });
      }
      axios
        .get(url, configuracion)
        .then(function(response) {
          //console.log(response);
          me.socios = response.data;
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.status === 401) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    bitacora() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      // Bitacora
      axios
        .post(
          "api/Bitacoras/Crear",
          {
            socioid: me.socioid,
            bitacoranombre: "DOCUMENTO VIGENTE: DESCARGA DOCUMENTO SOCIO",
            usuarioid: me.$store.state.usuario.idusuario
          },
          configuracion
        )
        .then(function(response) {})
        .catch(function(error) {
          console.log(error);
        });
    },

    // Select de Tipo Operacion
    select() {
      let me = this;
      var tramiteArray = [];
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get("api/tramites/Select", configuracion)
        .then(function(response) {
          tramiteArray = response.data;
          me.tramiteselect.push({ text: "TODOS", value: 1 });
          tramiteArray.map(function(x) {
            me.tramiteselect.push({
              text: x.tramitenombre,
              value: x.tramiteid
            });
          });
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.status === 401) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    // lista los detalles
    TramiteDetalles() {
      if (this.validar()) {
        return;
      }
      this.tramitedetallemmodal = 1;
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/tramites/TramiteVigente/" + this.tramiteid + "/" + this.socioid,
          configuracion
        )
        .then(function(response) {
          me.tramitedetalles = response.data;
          //console.log(JSON.stringify(me.tramitedetalles));
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.status === 401) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    // lista los detalles
    TramiteDetallesDocumentos() {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      axios
        .get(
          "api/documentos/TramiteDetalleDocumentos/" +
            this.socioid +
            "/" +
            this.tramiteid,
          configuracion
        )
        .then(function(response) {
          me.sociodoc = response.data;
          if (me.sociodoc.length == 0) {
            me.$swal("El Socio no Tiene Documentos");
          }
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.status === 401) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
    },

    // Actualiza la categotia
    editItem(item) {
      let me = this;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      this.socioid = item.socioid;
      axios
        .get("api/documentos/ListarDocumentos/" + item.socioid, configuracion)
        .then(function(response) {
          me.sociodoc = response.data;
          if (me.sociodoc.length == 0) {
            me.$swal("El Socio no Tiene Documentos");
          }
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.status === 401) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });
      this.TablaVisible = 1;

      // Bitacora
      axios
        .post(
          "api/Bitacoras/Crear",
          {
            socioid: item.socioid,
            bitacoranombre: "DOCUMENTO VIGENTE: VER SOCIO DOCUMENTO",
            usuarioid: me.$store.state.usuario.idusuario
          },
          configuracion
        )
        .then(function(response) {})
        .catch(function(error) {
          console.log(error);
        });
    },

    // Actualiza la categotia
    excel(item) {
      let me = this;
      this.reportes = true;
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };
      this.socioid = item.socioid;
      axios
        .get("api/documentos/ListarDocumentos/" + item.socioid, configuracion)
        .then(function(response) {
          me.data = response.data;
          me.sociodoc = response.data;
        })
        .catch(function(error) {
          console.log(error);
          if (error.response.status === 401) {
            me.$swal("La Sesión a Expirado");
            me.$store.dispatch("salir");
          }
        });

      // Bitacora
      axios
        .post(
          "api/Bitacoras/Crear",
          {
            socioid: item.socioid,
            bitacoranombre: "DOCUMENTO VIGENTE: REPORTE EXCEL SOCIO DOCUMENTO",
            usuarioid: me.$store.state.usuario.idusuario
          },
          configuracion
        )
        .then(function(response) {})
        .catch(function(error) {
          console.log(error);
        });
    },

    deleteItem(item) {
      const index = this.desserts.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.desserts.splice(index, 1);
    },

    close() {
      this.reportes = false;
      this.TablaVisible = 0;
      this.limpiar();
    },

    limpiar() {
      this.socionombre = "";
      this.sociopaterno = "";
      this.sociomaterno = "";
    },

    validar() {
      this.valida = 0;
      this.validamensaje = [];

      if (!this.tramiteid) {
        this.validamensaje.push("No se a Seleccionado el Tramite");
      }

      if (this.validamensaje.length) {
        this.valida = 1;
      }
      return this.valida;
    },

    ActivarDesactivarMostrar(accion, item) {
      this.adModal = 1;
      this.adNombre = item.tasadescripcion;
      this.adId = item.tasaid;
      if (accion == 1) {
        this.adAccion = 1;
      } else if (accion == 2) {
        this.adAccion = 2;
      } else {
        this.adModal = 0;
      }
    },
    activarDesactivarCerrar() {
      this.adModal = 0;
    }
  }
};
</script>